module.exports = __webpack_public_path__ + "img/strong_wind.886d65cc.svg";